// Summaros — client-side auth token storage.
//
// Backend sets HTTP-only session cookies with SameSite=None; Secure.
// That works on Chrome/Firefox/Edge but Safari and iOS WebKit routinely
// drop those cookies under ITP when the frontend origin and API origin
// differ. Fix: the /auth/session response echoes a session_token in
// the JSON body; we persist it in localStorage and attach it as
// Authorization: Bearer <token>. Cookies remain the primary path;
// the bearer is the belt-and-braces fallback.
import axios from 'axios';

const USER_TOKEN_KEY = 'summaros:auth-token';

const safeStorage = () => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      return window.localStorage;
    }
  } catch {
    /* localStorage disabled (privacy mode, sandbox) */
  }
  return null;
};

export const setAuthToken = (token) => {
  if (!token) return;
  const store = safeStorage();
  try { store?.setItem(USER_TOKEN_KEY, token); } catch { /* ignore */ }
};

export const getAuthToken = () => {
  const store = safeStorage();
  try { return store?.getItem(USER_TOKEN_KEY) || null; } catch { return null; }
};

export const clearAuthToken = () => {
  const store = safeStorage();
  try { store?.removeItem(USER_TOKEN_KEY); } catch { /* ignore */ }
};

let installed = false;
export const installAuthInterceptor = () => {
  if (installed) return;
  installed = true;

  axios.defaults.withCredentials = true;

  axios.interceptors.request.use((config) => {
    config.headers = config.headers || {};
    if (config.headers.Authorization || config.headers.authorization) {
      return config;
    }
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });
};
